import React, { useEffect, useMemo, useState } from "react";
import {
  Autocomplete,
  Avatar,
  Box,
  Button,
  Card,
  Grid,
  IconButton,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  FormControlLabel,
  Checkbox,
  CircularProgress,
  FormGroup,
} from "@mui/material";
import { useFormik } from "formik";
import CloseIcon from "@mui/icons-material/Close";
import {
  useCreateCustomerMutation,
  useGetCustomerFilterByPerentQuery,
  useGetClientTypeQuery,
} from "../../../Api/attoDeskApi";
import { useNotifier } from "../../../Core/Notifier";
import { useStyles } from "../../../theme/appStyles";
import { useNavigate } from "react-router";
import {
  formatPhoneNumberForDisplay,
  validateEmail,
  validatePhoneNumber,
} from "../../../Components/Validation/validationUtils";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  ClientSource,
  ClientStatus,
  ClientType,
  Gender,
  MaritalStatus,
  RelationshipType,
  ReminderPolicyBeforeOption,
} from "../../../Core/Enum/enum";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import {
  ICustomerForm,
  ICustomerRelative,
  ICustomer,
  IClientType,
  CustomerOptionString,
} from "../../../Api/Interface/api.interface";
import { FaTrash } from "react-icons/fa";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

function getInsuranceClient(customerClientId: string) {
  switch (customerClientId) {
    case ClientType.InsuranceClient:
      return "Insurance Client";
    case ClientType.RealstatesClient:
      return "Real estate Client";
    default:
      return "";
  }
}

const toAllCaps = (text: string | null | undefined): string => {
  if (!text) return "";
  return text.toUpperCase();
};

interface CustomerOption {
  label: string;
  value: number;
}

const Index = () => {
  const classes = useStyles();
  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const [newTax, { isLoading }] = useCreateCustomerMutation();
  const { showErrorMessage, showMessage } = useNotifier();
  const [addedRelative, setAddedRelative] = useState<ICustomerRelative[]>([]);
  const handlePhoneChange = (
    fieldName: string,
    value: string,
    setFieldValue: (field: string, value: any) => void
  ) => {
    const formattedValue = formatPhoneNumberForDisplay(value);
    setFieldValue(fieldName, formattedValue);
  };
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const debouncedSearchQuery = useDebounce(searchQuery, 300);

  const {
    data: allClientData,
    isLoading: allClientIsLoading,
    refetch,
  } = useGetCustomerFilterByPerentQuery({
    searchText: "",
    id: "",
    // isParent: selectedIsBooked,
    isParentFilter: "",
    isParent: "all",
    customerClientId: "all",
  });

  const { data: clientData, isLoading: cilentIsLoading } =
    useGetClientTypeQuery({
      searchText: "",
      id: "",
    });

  const cliendList = useMemo(() => {
    return (clientData?.data ?? []) as IClientType[];
  }, [clientData?.data]);

  const allCliendUpList = useMemo(() => {
    return (allClientData?.data ?? []) as ICustomer[];
  }, [allClientData?.data]);

  const customerOptions = useMemo(() => {
    if (!Array.isArray(cliendList)) return [];
    return cliendList.map((cust) => ({
      label: `${toProperCase(cust.client_type)}`,
      value: cust.id,
    }));
  }, [cliendList]);

  const clientOptions = useMemo(() => {
    if (!Array.isArray(allCliendUpList)) return [];
    return allCliendUpList.map((cust) => ({
      label: `${toProperCase(cust.customerFirstName)} ${toProperCase(
        cust.customerLastName
      )}`,
      value: cust.id,
    }));
  }, [allCliendUpList]);

  useEffect(() => {
    if (debouncedSearchQuery.length >= 2 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const reminderBeforOptions: CustomerOptionString[] = Object.values(
    ReminderPolicyBeforeOption
  ).map((day) => ({
    label: day,
    value: day,
  }));

  const formik = useFormik<ICustomerForm>({
    initialValues: {
      customerClientId: "2",
      customerFirstName: "",
      customerLastName: "",
      customerMobileNum: "",
      customerEmail: "",
      customerDescription: "",
      customerDateOfBirth: null,
      customerGenderId: "",
      customerBloodGroupId: "",
      customerHeight: "",
      customerWeight: "",
      customerMaritalStatusId: "",
      customerAddresLine: "",
      customerCity: "",
      customerProvince: "",
      customerPostalCode: "",
      customerPreferTimeToCall: "",
      customerClientStatusId: "",
      customerClientSource: "",
      customerContactStage: "",
      customerWorkMobileNum: "",
      customerHomeMobileNum: "",
      customerRefId: "",
      customerPreAddress: "",
      customerRemark: "",
      relationShip: [],
      isPerent: true,
      referredByIds: [],
      policyReminder: "",
      isBirthdayReminderSms: false,

    },
    enableReinitialize: true,
    validate: (values) => {
      const errors: { [key: string]: string } = {};

      const customerEmailError = validateEmail(values.customerEmail);
      if (customerEmailError) {
        errors.customerEmail = customerEmailError;
      }
      const cutomerMobileNumberError = validatePhoneNumber(
        values.customerMobileNum
      );
      if (cutomerMobileNumberError) {
        errors.customerMobileNum = cutomerMobileNumberError;
      }

      const customerWorkMobileNumError = validatePhoneNumber(
        values.customerWorkMobileNum
      );
      if (customerWorkMobileNumError) {
        errors.customerWorkMobileNum = customerWorkMobileNumError;
      }

      const customerHomeMobileNumError = validatePhoneNumber(
        values.customerHomeMobileNum
      );
      if (customerHomeMobileNumError) {
        errors.customerHomeMobileNum = customerHomeMobileNumError;
      }

      if (values.customerDateOfBirth) {
        const selectedDate = values.customerDateOfBirth.toDate();
        const today = new Date();
        if (selectedDate >= today) {
          errors.customerDateOfBirth = "Date of Birth must be in the past";
        }
      }

      return errors;
    },

    onSubmit: async (values, { resetForm }) => {
      try {
        if (addedRelative.length > 0) {
          const hasInvalidRelationship = addedRelative.some(
            (rel) => !rel.related_customer_id || !rel.relationship_type
          );

          if (hasInvalidRelationship) {
            showErrorMessage(
              "Please complete all relationship entries (both client and relationship type)."
            );
            return;
          }

          const seen = new Set<number>();
          const hasDuplicate = addedRelative.some((rel) => {
            if (rel.related_customer_id === null) return false;
            if (seen.has(rel.related_customer_id)) return true;
            seen.add(rel.related_customer_id);
            return false;
          });

          if (hasDuplicate) {
            showErrorMessage("Each related client must be unique.");
            return;
          }
        }

        const filteredRelationship = addedRelative.filter(
          (rel) => rel.related_customer_id && rel.relationship_type
        );

        const temData = {
          customerClientId: String(values.customerClientId),
          customerFirstName: toProperCase(values.customerFirstName),
          customerLastName: toProperCase(values.customerLastName),
          customerMobileNum: values.customerMobileNum.replace(/-/g, ""),
          customerEmail: values.customerEmail?.trim().toLowerCase(),
          customerDescription: values.customerDescription,
          customerDateOfBirth: values.customerDateOfBirth
          ? values.customerDateOfBirth.format("YYYY-MM-DD")
          : null,        
          customerGenderId: values.customerGenderId,
          customerBloodGroupId: values.customerBloodGroupId,
          customerHeight: values.customerHeight,
          customerWeight: values.customerWeight,
          customerMaritalStatusId: values.customerMaritalStatusId,
          customerAddresLine: toProperCase(values.customerAddresLine),
          customerCity: toProperCase(values.customerCity),
          customerProvince: toProperCase(values.customerProvince),
          customerPostalCode: toAllCaps(values.customerPostalCode),
          customerPreferTimeToCall: values.customerPreferTimeToCall,
          customerClientStatusId: values.customerClientStatusId,
          customerClientSource: values.customerClientSource,
          customerContactStage: values.customerContactStage,
          customerWorkMobileNum: values.customerWorkMobileNum.replace(/-/g, ""),
          customerHomeMobileNum: values.customerHomeMobileNum.replace(/-/g, ""),
          customerRefId: values.customerRefId,
          customerPreAddress: toProperCase(values.customerPreAddress),
          customerRemark: values.customerRemark,
          relationShip: filteredRelationship,
          isPerent: values.isPerent,
          referredByIds: values.referredByIds,
          policyReminder: values.policyReminder,
          isBirthdayReminderSms: values.isBirthdayReminderSms,
        };

        const addCompanyResponse = await newTax(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          // navigate(`/customer-deals/${addCompanyResponse.data.id}`);
          navigate(`/profile/customer/${addCompanyResponse.data.id}`);
          resetForm();
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const formValid = useMemo(() => {
    return (
      (formik.values.customerFirstName !== "" &&
        formik.values.customerFirstName !== undefined) ||
      (formik.values.customerLastName !== "" &&
        formik.values.customerLastName !== undefined)
    );
  }, [formik.values.customerFirstName, formik.values.customerLastName]);

  const gridHeight = isMobile ? "30px" : "400px";

  const handleFieldChangeRelative = <K extends keyof ICustomerRelative>(
    index: number,
    field: K,
    value: ICustomerRelative[K]
  ) => {
    const updatedRows = addedRelative.map((term, i) => {
      if (i === index) {
        return {
          ...term,
          [field]: value !== undefined ? value : term[field],
        };
      }
      return term;
    });

    setAddedRelative(updatedRows);
  };

  const cancelFunction = () => {
    formik.resetForm();
    setAddedRelative([]);
  };

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item lg={3} md={12} sm={12} xs={12}>
          <Card className={classes.stepperCard}>
            <Grid
              container
              justifyContent={"space-between"}
              spacing={5}
              sx={{ borderBottom: 2, padding: 2 }}
              className={classes.titleGrid}
            >
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                pt={2}
                alignContent={"center"}
              >
                <Typography className={classes.cardTitle}>
                  Create Client
                </Typography>
              </Grid>
            </Grid>
          </Card>
        </Grid>
        <Grid item lg={9} md={12} sm={12} xs={12}>
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={3}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid item pt={2} alignContent={"center"}>
                      <Typography className={classes.cardTitle}>
                        Client Information
                      </Typography>
                    </Grid>
                    {/* <Grid
                      item
                      pt={2}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Grid
                        container
                        spacing={1}
                        justifyContent="flex-end"
                        sx={{ display: "flex" }}
                      >
                        <Grid item>
                          <TextField
                            select
                            size="small"
                            sx={{ flexGrow: 1, width: "100%" }}
                            {...formik.getFieldProps("customerClientId")}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                              classes: {
                                root: classes.formControlListStatus,
                              },
                            }}
                            className={classes.searchTextField34}
                          >
                            <MenuItem value="" disabled>
                              Select an option
                            </MenuItem>

                            {Object.entries(ClientType).map(
                              ([key, value], index) => (
                                <MenuItem key={index} value={value}>
                                  {getInsuranceClient(value)}
                                </MenuItem>
                              )
                            )}
                          </TextField>
                        </Grid>
                      </Grid>
                    </Grid> */}
                  </Grid>

                  <Grid container spacing={3} p={"24px"}>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">Client Id</Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Client Id"
                            size="small"
                            {...formik.getFieldProps("customerRefId")}
                            className={classes.textField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Client Type
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Autocomplete
                            options={customerOptions}
                            loading={cilentIsLoading}
                            getOptionLabel={(option: CustomerOption) =>
                              option.label
                            }
                            value={
                              customerOptions.find(
                                (opt) =>
                                  opt.value ===
                                  Number(formik.values.customerClientId)
                              ) || null
                            }
                            onChange={(_, newValue: CustomerOption | null) => {
                              formik.setFieldValue(
                                "customerClientId",
                                newValue?.value || ""
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Client Type.."
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                className="textField"
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      {cilentIsLoading ? (
                                        <CircularProgress size={20} />
                                      ) : null}
                                      {params.InputProps.endAdornment}
                                    </>
                                  ),
                                }}
                              />
                            )}
                            sx={{ width: "100%" }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            First Name{" "}
                            <span className={classes.requiedfield}>*</span>
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="First Name"
                            size="small"
                            {...formik.getFieldProps("customerFirstName")}
                            className={classes.textField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Last Name{" "}
                            <span className={classes.requiedfield}>*</span>
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Last Name"
                            size="small"
                            {...formik.getFieldProps("customerLastName")}
                            className={classes.textField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">E-mail</Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="E-mail"
                            size="small"
                            type="email"
                            {...formik.getFieldProps("customerEmail")}
                            className={classes.textField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            error={
                              formik.touched.customerEmail &&
                              Boolean(formik.errors.customerEmail)
                            }
                            helperText={
                              formik.touched.customerEmail &&
                              formik.errors.customerEmail
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Cell Phone Number
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Cell Phone Number"
                            size="small"
                            value={formik.values.customerMobileNum}
                            onChange={(e) =>
                              handlePhoneChange(
                                "customerMobileNum",
                                e.target.value,
                                formik.setFieldValue
                              )
                            }
                            onBlur={formik.handleBlur}
                            className={classes.textField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            error={
                              formik.touched.customerMobileNum &&
                              Boolean(formik.errors.customerMobileNum)
                            }
                            helperText={
                              formik.touched.customerMobileNum &&
                              formik.errors.customerMobileNum
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Work Phone Number
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Work Phone Number"
                            size="small"
                            value={formik.values.customerWorkMobileNum}
                            onChange={(e) =>
                              handlePhoneChange(
                                "customerWorkMobileNum",
                                e.target.value,
                                formik.setFieldValue
                              )
                            }
                            onBlur={formik.handleBlur}
                            className={classes.textField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            error={
                              formik.touched.customerWorkMobileNum &&
                              Boolean(formik.errors.customerWorkMobileNum)
                            }
                            helperText={
                              formik.touched.customerWorkMobileNum &&
                              formik.errors.customerWorkMobileNum
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Home Phone Number
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Home Phone Number"
                            size="small"
                            value={formik.values.customerHomeMobileNum}
                            onChange={(e) =>
                              handlePhoneChange(
                                "customerHomeMobileNum",
                                e.target.value,
                                formik.setFieldValue
                              )
                            }
                            onBlur={formik.handleBlur}
                            className={classes.textField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            error={
                              formik.touched.customerHomeMobileNum &&
                              Boolean(formik.errors.customerHomeMobileNum)
                            }
                            helperText={
                              formik.touched.customerHomeMobileNum &&
                              formik.errors.customerHomeMobileNum
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>
                        Address Details
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid container spacing={3} p={"24px"}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">Street</Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Street "
                            size="small"
                            {...formik.getFieldProps("customerAddresLine")}
                            className={classes.textField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">City</Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="City"
                            size="small"
                            {...formik.getFieldProps("customerCity")}
                            className={classes.textField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            State/Province
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="State/Province"
                            size="small"
                            {...formik.getFieldProps("customerProvince")}
                            className={classes.textField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Postal/Zip Code
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Postal/Zip Code"
                            size="small"
                            type="email"
                            {...formik.getFieldProps("customerPostalCode")}
                            className={classes.textField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Previous Address
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Previous Address"
                            size="small"
                            multiline
                            rows={3}
                            {...formik.getFieldProps("customerPreAddress")}
                            className={classes.textField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>
                        personal Information
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid container spacing={3} p={"24px"}>
                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Date Of Birth
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              value={formik.values.customerDateOfBirth}
                              onChange={(date) =>
                                formik.setFieldValue(
                                  "customerDateOfBirth",
                                  date
                                )
                              }
                              slotProps={{
                                textField: {
                                  size: "small",
                                  sx: { width: "100%" },
                                  error: Boolean(
                                    formik.errors.customerDateOfBirth
                                  ),
                                  helperText: formik.errors.customerDateOfBirth,
                                  InputProps: {
                                    sx: { fontSize: 14 },
                                  },
                                  InputLabelProps: {
                                    sx: { fontSize: 14 },
                                  },
                                },
                              }}
                            />
                          </LocalizationProvider>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">Gender</Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            select
                            size="small"
                            className={classes.textField}
                            SelectProps={{
                              native: false,
                            }}
                            defaultValue=""
                            InputLabelProps={{ shrink: true }}
                            {...formik.getFieldProps("customerGenderId")}
                          >
                            <MenuItem value="" disabled>
                              Select an option
                            </MenuItem>

                            {Object.entries(Gender).map(
                              ([key, value], index) => (
                                <MenuItem key={index} value={value}>
                                  {key}
                                </MenuItem>
                              )
                            )}
                          </TextField>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Marital Status
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            select
                            size="small"
                            className={classes.textField}
                            SelectProps={{
                              native: false,
                            }}
                            defaultValue=""
                            InputLabelProps={{ shrink: true }}
                            {...formik.getFieldProps("customerMaritalStatusId")}
                          >
                            <MenuItem value="" disabled>
                              Select an option
                            </MenuItem>

                            {Object.entries(MaritalStatus).map(
                              ([key, value], index) => (
                                <MenuItem key={index} value={value}>
                                  {key}
                                </MenuItem>
                              )
                            )}
                          </TextField>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                          Send Birthday Wishes
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={formik.values.isBirthdayReminderSms}
                                  onChange={(e) =>
                                    formik.setFieldValue(
                                      "isBirthdayReminderSms",
                                      e.target.checked
                                    )
                                  }
                                  size="small"
                                />
                              }
                              label="SMS"
                            />
                          </FormGroup>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>
                        Other
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid container spacing={3} p={"24px"}>
                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Prefer Time to call
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Prefer Time to call"
                            size="small"
                            {...formik.getFieldProps(
                              "customerPreferTimeToCall"
                            )}
                            className={classes.textField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Client Status
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            select
                            size="small"
                            className={classes.textField}
                            SelectProps={{
                              native: false,
                            }}
                            defaultValue=""
                            InputLabelProps={{ shrink: true }}
                            {...formik.getFieldProps("customerClientStatusId")}
                          >
                            <MenuItem value="" disabled>
                              Select an option
                            </MenuItem>

                            {Object.entries(ClientStatus).map(
                              ([key, value], index) => (
                                <MenuItem key={index} value={value}>
                                  {key}
                                </MenuItem>
                              )
                            )}
                          </TextField>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Client Source
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            select
                            size="small"
                            className={classes.textField}
                            SelectProps={{
                              native: false,
                            }}
                            defaultValue=""
                            InputLabelProps={{ shrink: true }}
                            {...formik.getFieldProps("customerClientSource")}
                          >
                            <MenuItem value="" disabled>
                              Select an option
                            </MenuItem>

                            {Object.entries(ClientSource).map(
                              ([key, value], index) => (
                                <MenuItem key={index} value={value}>
                                  {key}
                                </MenuItem>
                              )
                            )}
                          </TextField>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Contact Stage
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Contact Stage"
                            size="small"
                            {...formik.getFieldProps("customerContactStage")}
                            className={classes.textField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={4} md={4} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Remind Before Policy Renewal Date
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Autocomplete
                            options={reminderBeforOptions}
                            getOptionLabel={(option: CustomerOptionString) =>
                              option.label
                            }
                            value={
                              reminderBeforOptions.find(
                                (opt) =>
                                  opt.value ===
                                  String(formik.values.policyReminder)
                              ) || null
                            }
                            onChange={(
                              _,
                              newValue: CustomerOptionString | null
                            ) => {
                              formik.setFieldValue(
                                "policyReminder",
                                newValue?.value || ""
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Remind Before .."
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                className="textField"
                                InputProps={{
                                  ...params.InputProps,
                                }}
                              />
                            )}
                            sx={{ width: "100%" }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">
                            Referred by (Client ID / Name)
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Grid container spacing={2} alignItems="center">
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Autocomplete
                                multiple
                                options={clientOptions}
                                loading={allClientIsLoading}
                                getOptionLabel={(option: CustomerOption) =>
                                  option.label
                                }
                                value={clientOptions.filter((opt) =>
                                  formik.values.referredByIds.includes(
                                    opt.value
                                  )
                                )}
                                onChange={(_, newValues: CustomerOption[]) => {
                                  formik.setFieldValue(
                                    "referredByIds",
                                    newValues.map((val) => val.value)
                                  );
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Add Referred by clients..."
                                    fullWidth
                                    size="small"
                                    className={classes.textField}
                                    InputProps={{
                                      ...params.InputProps,
                                      sx: {
                                        fontSize: 14,
                                        border: "none",
                                        minWidth: "150px",
                                      },
                                      // classes: {
                                      //   root: classes.textFieldQuote,
                                      //   notchedOutline:
                                      //     classes.notchedOutline,
                                      // },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        fontSize: 14,
                                        border: "none",
                                      },
                                    }}
                                  />
                                )}
                                size="small"
                                className={classes.textField}
                              />
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <TextField
                                placeholder="Referred by Note .."
                                size="small"
                                multiline
                                rows={4}
                                {...formik.getFieldProps("customerHeight")}
                                className={classes.textField}
                                InputProps={{
                                  sx: {
                                    fontSize: 14,
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    fontSize: 14,
                                  },
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>
                        Note
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid container spacing={3} p={"24px"}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography variant="subtitle1">Remark</Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <TextField
                            placeholder="Remark .."
                            size="small"
                            multiline
                            rows={8}
                            {...formik.getFieldProps("customerRemark")}
                            className={classes.discriptionTextField}
                            InputProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                            InputLabelProps={{
                              sx: {
                                fontSize: 14,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>
                        RelationShip
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid container spacing={3}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid container px={2}>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={formik.values.isPerent}
                                onChange={formik.handleChange}
                                name="isPerent"
                                color="primary"
                              />
                            }
                            label="Is Parent "
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid container alignItems="center">
                        <TableContainer>
                          <Table className={classes.table}>
                            <TableHead className={classes.tableHeaderRow}>
                              <TableRow>
                                <TableCell className={classes.tablheader}>
                                  Name
                                </TableCell>
                                <TableCell className={classes.tablheader}>
                                  RelationShip
                                </TableCell>
                                <TableCell
                                  className={classes.tablheader}
                                  sx={{ textAlign: "end" }}
                                >
                                  Action
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {addedRelative.map((item, index) => {
                                const selectedClient =
                                  clientOptions.find(
                                    (opt) =>
                                      opt.value === item.related_customer_id
                                  ) || null;

                                return (
                                  <TableRow key={index}>
                                    <TableCell className={classes.tablCell}>
                                      <Autocomplete
                                        options={clientOptions}
                                        value={selectedClient}
                                        getOptionLabel={(option) =>
                                          option.label
                                        }
                                        onChange={(_, newValue) => {
                                          handleFieldChangeRelative(
                                            index,
                                            "related_customer_id",
                                            newValue?.value || null
                                          );
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            placeholder="Search related clients"
                                            size="small"
                                            className={classes.textField}
                                            InputProps={{
                                              ...params.InputProps,
                                              sx: {
                                                fontSize: 14,
                                                border: "none",
                                                minWidth: "150px",
                                              },
                                              classes: {
                                                root: classes.textFieldQuote,
                                                notchedOutline:
                                                  classes.notchedOutline,
                                              },
                                            }}
                                            InputLabelProps={{
                                              sx: {
                                                fontSize: 14,
                                                border: "none",
                                              },
                                            }}
                                          />
                                        )}
                                        sx={{ width: "200px" }}
                                        size="small"
                                        className={classes.searchTextField23}
                                      />
                                    </TableCell>

                                    <TableCell className={classes.tablCell}>
                                      <Autocomplete
                                        options={Object.values(
                                          RelationshipType
                                        )}
                                        value={item.relationship_type || ""}
                                        onChange={(event, newValue) =>
                                          handleFieldChangeRelative(
                                            index,
                                            "relationship_type",
                                            newValue || ""
                                          )
                                        }
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            placeholder="Relationship.."
                                            size="small"
                                            className={classes.textField}
                                            InputProps={{
                                              ...params.InputProps,
                                              sx: {
                                                fontSize: 14,
                                                border: "none",
                                                minWidth: "150px",
                                              },
                                              classes: {
                                                root: classes.textFieldQuote,
                                                notchedOutline:
                                                  classes.notchedOutline,
                                              },
                                            }}
                                            InputLabelProps={{
                                              sx: {
                                                fontSize: 14,
                                                border: "none",
                                              },
                                            }}
                                          />
                                        )}
                                        sx={{ width: "200px" }}
                                        size="small"
                                        className={classes.searchTextField23}
                                      />
                                    </TableCell>

                                    <TableCell className={classes.tablCell}>
                                      <Grid
                                        container
                                        spacing={1}
                                        sx={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                        }}
                                      >
                                        <Grid item>
                                          <IconButton
                                            color="error"
                                            onClick={() => {
                                              const updated = [
                                                ...addedRelative,
                                              ];
                                              updated.splice(index, 1);
                                              setAddedRelative(updated);
                                            }}
                                          >
                                            <FaTrash />
                                          </IconButton>
                                        </Grid>
                                      </Grid>
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>

                        {/* Add Relative Button (Flex End) */}
                        <Grid container justifyContent="flex-end" mt={1} p={2}>
                          <Button
                            variant="contained"
                            className={classes.addButton}
                            onClick={() =>
                              setAddedRelative((prev) => [
                                ...prev,
                                {
                                  related_customer_id: null,
                                  relationship_type: "",
                                  id: null,
                                  customer_id: null,
                                },
                              ])
                            }
                          >
                            + Add Relative
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                <Card className={classes.card}>
                  <Grid container spacing={3} p={"24px"}>
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Button
                        variant="outlined"
                        startIcon={<CloseIcon />}
                        className={classes.addButton}
                        onClick={cancelFunction}
                      >
                        Reset
                      </Button>
                      <Box m={0.5}></Box>

                      <Button
                        variant="contained"
                        startIcon={<CheckCircleOutlineIcon />}
                        className={classes.addButton}
                        onClick={() => formik.handleSubmit()}
                        disabled={!formValid || isLoading}
                      >
                        Create
                      </Button>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </div>
  );
};

export default Index;
